import React from 'react'
import {
  UsersIcon,
  BuildingStorefrontIcon,
  TruckIcon,
  CreditCardIcon,
  TagIcon,
  LifebuoyIcon,
  FlagIcon,
  CheckBadgeIcon,
} from '@heroicons/react/24/outline'

export const adminMenuItems = [
  {
    key: 'customers',
    label: 'Customers',
    icon: <UsersIcon className="w-6 h-6" />,
    title: 'Customer Management',
    link: '/admin/customers',
  },
  {
    key: 'retailers',
    label: 'Retailers',
    icon: <BuildingStorefrontIcon className="w-6 h-6" />,
    title: 'Retailer Management',
    link: '/admin/retailers',
  },
  {
    key: 'wholesellers',
    label: 'Wholesalers',
    icon: <TruckIcon className="w-6 h-6" />,
    title: 'Wholesaler Management',
    link: '/admin/wholesellers',
  },
  {
    key: 'shop-verifications',
    label: 'Verifications',
    icon: <CheckBadgeIcon className='w-6 h-6'/>,
    title: 'Shop Verifications',
    link: '/admin/shop-verifications',
  },
  {
    key: 'subscriptions',
    label: 'Subscriptions',
    icon: <CreditCardIcon className="w-6 h-6" />,
    title: 'Subscriptions',
    link: '/admin/subscriptions',
  },
  {
    key: 'promotions',
    label: 'Promotions',
    icon: <TagIcon className="w-6 h-6" />,
    title: 'Promotions',
    link: '/admin/promotions',
  },
  {
    key: 'support',
    label: 'Support',
    icon: <LifebuoyIcon className="w-6 h-6" />,
    title: 'Support',
    link: '/admin/support',
  },
  {
    key: 'moderation',
    label: 'Moderation',
    icon: <FlagIcon className="w-6 h-6" />,
    title: 'Moderation',
    link: '/admin/moderation',
  },
]
